import { MutableRefObject, RefObject } from 'react';

export function centerCollectionAtIndex(
  index: number,
  container: RefObject<HTMLDivElement>,
  collections: MutableRefObject<HTMLButtonElement[]>,
) {
  if (!container.current) return;

  const targetCollection = collections.current[index];

  if (!targetCollection) return;

  const middleOfContainerXCoord = centerXCoord(container.current.getBoundingClientRect());
  const middleOfTargetCollectionXCoord = centerXCoord(targetCollection.getBoundingClientRect());

  container.current.scrollBy(middleOfTargetCollectionXCoord - middleOfContainerXCoord, 0);
}

function centerXCoord(rect: DOMRect) {
  // Absolute x-coordinate, takes padding/position into consideration
  const xPosition = rect.x;
  const widthOfElement = rect.width;

  return xPosition + widthOfElement / 2;
}
